import { HeaderActions, HeaderType } from './header.interface';
import { HeaderActionsType } from './reducer';

export const updateHeaderHeight = ({ height }: HeaderType): HeaderActionsType => ({
  type: HeaderActions.UpdateHeight,
  payload: height,
});
